import { useEffect } from 'react'
import { IISMethods, socket } from './../../config/IISMethods';

export const useSocket = (ename,) => {
    let loginInfo = IISMethods.getCookiesData("loginInfo")

    //PRIYANSHI --> SOCKET
    const socketEmit = (ekey, evalue = loginInfo.uid) => {
        let sessionData = IISMethods.getSessionData("sessionData")
        // Add the room to the subscribed rooms in sessionData
        if (ekey == 'subscribe' || ekey == 'setuid') {
            if(!sessionData.subscribedSocket){
                sessionData.subscribedSocket = []
            }
    
            // Check if the object with the same 'value' already exists
            if (!sessionData.subscribedSocket?.some((room) => room.value === evalue && room.key === ekey)) {
                sessionData.subscribedSocket?.push({ key: ekey, value: evalue })
            }
            IISMethods.setSessionData("sessionData", sessionData) // Save updated session data
        }
        else if (ekey == 'unsubscribe') {
            // Remove the room from sessionData where 'value' matches
            sessionData.subscribedSocket = sessionData.subscribedSocket?.filter(
                (room) => room.value !== evalue && room.key !== ekey
            )
            IISMethods.setSessionData("sessionData", sessionData) // Save updated session data
        }

        // socket.emit(ekey, evalue)
        socket.emit(ekey, IISMethods.getEDD(1, evalue))
    }

    const socketOff = (ekey = ename, lister = () => { }) => socket.off(ekey, lister)

    return {
        socketEmit,
        socketOff,
        eventname: ename
    }
}

export const useSocketListener = (ename, listener) => {
    
    useEffect(() => {

        socket.on(ename, (data) => listener(IISMethods.getEDD(2, data)));
        // socket.on(ename, (data) => listener(data));
        return () => socketOff(ename)
    }, [])

    const socketOff = () => socket.off(ename, () => { })
    
}